import { getCurrentInstance } from "vue";
const useCurrentComponentId = () => {
  const instance = getCurrentInstance();
  return `${instance.appContext.app._uid}_${instance.uid}`;
};
export {
  useCurrentComponentId as u
};
//# sourceMappingURL=useCurrentComponentId-01b0304d.mjs.map
